import { render, staticRenderFns } from "./TimeSinceLastVisitPivot.vue?vue&type=template&id=595e0f3c&scoped=true"
import script from "./TimeSinceLastVisitPivot.vue?vue&type=script&lang=ts"
export * from "./TimeSinceLastVisitPivot.vue?vue&type=script&lang=ts"
import style0 from "./TimeSinceLastVisitPivot.vue?vue&type=style&index=0&id=595e0f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595e0f3c",
  null
  
)

export default component.exports